// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { call, put, takeLatest } from 'redux-saga/effects';
import CommonDal from './../../../dal/CommonDal';
import {
    getProvincesData,
    GET_PROVINCES_DATA,
    getProvincesDataSuccess,
} from './../../../store/provinces';

import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

function* getProvinces(): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({
                actionName: GET_PROVINCES_DATA,
            })
        );

        const response = yield call(CommonDal.getProvinces);

        yield put(getProvincesDataSuccess(response));

        yield put(
            actionStatusSuccess({
                actionName: GET_PROVINCES_DATA,
            })
        );
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: GET_PROVINCES_DATA,
                error: e,
            })
        );
    }
}

export default [takeLatest(`${getProvincesData}`, getProvinces)];
